import { render, staticRenderFns } from "./AdminCampaignReview.vue?vue&type=template&id=1c42e8ae&scoped=true&"
import script from "./AdminCampaignReview.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignReview.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCampaignReview.vue?vue&type=style&index=0&id=1c42e8ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42e8ae",
  null
  
)

export default component.exports